import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PatientDetailsWrapper from "../../patientDetails/components/PatientDetailsWrapper.style";
import moment from "moment";
import { useUserBranches } from "../../../hooks/accessControl";
import { Tag } from "antd";
import AttributesList from "../../../components/layouts/AttributesList";

const OpportunityDetailsHeader = () => {
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const userBranches = useUserBranches();
  const [branchName, setBranchName] = useState(null);
  const [attributes, setAttributes] = useState({});

  useEffect(() => {
    const newAttributes = {};
    const { id, local_id_number, registered_at, created_at, updated_at } =
      activePatient;
    if (id) newAttributes["app.forms.patient.id"] = id;
    if (local_id_number)
      newAttributes["app.forms.patient.local_id_number"] = local_id_number;
    if (registered_at)
      newAttributes["app.forms.patient.registered_at"] =
        moment(registered_at).format("l");
    if (created_at)
      newAttributes["app.forms.patient.created_at"] =
        moment(created_at).format("l");
    if (updated_at)
      newAttributes["app.forms.patient.updated_at"] =
        moment(updated_at).format("l");
    setAttributes(newAttributes);
  }, [activePatient]);

  useEffect(() => {
    const branch = userBranches.find(
      (branch) => branch.id === activePatient.branch_id
    );
    if (branch) {
      setBranchName(branch.name);
    }
  }, [userBranches, activePatient]);

  return (
    <PatientDetailsWrapper>
      <div style={{ paddingTop: "16px" }}>
        {branchName && <Tag color={"success"}>{branchName}</Tag>}
      </div>
      <AttributesList attributes={attributes} />
    </PatientDetailsWrapper>
  );
};

export default OpportunityDetailsHeader;
